module.exports = __webpack_public_path__ + "static/media/tiendaInglesa.9896a35d.svg";